import React from "react";

import { useTranslate } from "localization";
import { color } from "minimum-ui/tokens";
import styled from "styled-components";
import { H4M } from "typography/headers";
import { Filter } from "ui/forms";
import { GroupByOption, Option } from "ui/forms/Filter/Menu";

import useFilterParam from "./useFilterParam";

interface GroupProps {
  options: Option[] | GroupByOption[];
}

const Group: React.FC<GroupProps> = ({ options }) => {
  const { translate } = useTranslate();
  const title = translate("groupBy");

  const [selected, setSelected] = useFilterParam("group_by", options, {
    defaultToFirst: true,
  });

  const selectedLabel = options.find((o) => o.value === selected)?.label ?? "";
  return (
    <RightAlignedFilter>
      <Label>{title}</Label>
      <Filter
        items={{ options }}
        title={title}
        label={`${selectedLabel}`}
        onChange={setSelected}
        value={selected ?? ""}
        showReset={true}
        showApply={true}
        anchor="right"
        translate={translate}
      />
    </RightAlignedFilter>
  );
};

const Label = styled(H4M)`
  margin-right: 8px;
  color: ${color.neutral[400]};
`;

const RightAlignedFilter = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`;

export default Group;
